define("text!js-translation.json",[],(function(){return"[]"}));
